/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Startedat1Inputs */

const zh_learn_startedat1 = /** @type {(inputs: Learn_Startedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始于`)
};

const en_learn_startedat1 = /** @type {(inputs: Learn_Startedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Started`)
};

const es_learn_startedat1 = /** @type {(inputs: Learn_Startedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio`)
};

/**
* | output |
* | --- |
* | "Started" |
*
* @param {Learn_Startedat1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_startedat1 = /** @type {((inputs?: Learn_Startedat1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Startedat1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_startedat1(inputs)
	if (locale === "en") return en_learn_startedat1(inputs)
	return es_learn_startedat1(inputs)
});
export { learn_startedat1 as "learn_startedAt" }